<template>
    <div class="ParticipationForm">
        <div class="ParticipationForm_cennert">
            <h2>联系方式</h2>
            <div class="desc">致力于为客户提供整套3D展厅全新营销方案</div>
            <ul class="information">
                <li>
                    <div class="information_top">
                        <img src="../../assets/imges/Participation/informationli1.png"/>
                    </div>
                    <div class="information_right">
                        <h3>邮箱方式</h3>
                        <h5>请将您的资料发送到<span>info@3dyunchuang.com</span>
                        我们会尽快与您联系</h5>
                        <p>您的姓名 / 联系方式 / 地址等</p>
                    </div>
                </li>
                <li>
                     <div class="information_top">
                        <img src="../../assets/imges/Participation/informationli2.png"/>
                    </div>
                    <div class="information_right">
                        <h3>电话方式</h3>
                        <h5>您可以拨打电话<span>400-930-1887</span><br/>与我们取得联系</h5>
                    </div>
                </li>
                <li>
                     <div class="information_top">
                        <img src="../../assets/imges/Participation/informationli3.png"/>
                    </div>
                    <div class="information_right">
                        <h3>在线留言</h3>
                        <h5>您也可以<span>在线留言</span><br/>我们的工作人员会第一时间和您联系</h5>
                    </div>
                </li>
            </ul>
            <h2>在线留言</h2>
            <div class="desc">专业化，标准化，为您提供全方位高效服务</div>
            <div class="OnlineMessage">
                <ul class="OnlineMessage_ptop">
                    <li>
                        联系人:
                        <input class="ip" type="text" name="usr_name" placeholder="您的称呼" v-model="datali[0]" />
                    </li>
                    <li>
                        手机号码:
                         <input class="ip" oninput = "value = value.replace(/[^0-9]/g,'')" type="text" placeholder="手机号码"  name="usr_name" v-model="datali[1]" required="required" />
                    </li>
                    <li>
                        微信号:
                         <input class="ip"  placeholder="微信号"  type="text" name="usr_name" v-model="datali[2]" required="required" />
                    </li>
                    <li>
                        所在城市:
                         <input class="ip"  placeholder="如:北京" type="text" name="usr_name" v-model="datali[3]" required="required" />
                    </li>
                </ul>
                <div class="hallType">
                       <span>展厅类型:</span> 
                        <el-radio-group v-model="radio" @change = "pop1">
                            <el-radio label="0">展览会</el-radio>
                            <el-radio label="1">艺术画展</el-radio>
                            <el-radio label="2">企业展厅</el-radio>'
                            <el-radio label="3">沙盘模型</el-radio>
                            <el-radio label="4">城市馆</el-radio>
                            <el-radio label="5">VR直播</el-radio>'
                        </el-radio-group>
                </div>
                <div class="area">
                       <span>展厅面积:</span> 
                        <el-radio-group v-model="radio1" @change = "pop2">
                            <el-radio label="0">100-500㎡</el-radio>
                            <el-radio label="1">500-1000㎡</el-radio>
                            <el-radio label="2">1000-5000㎡</el-radio>'
                            <el-radio label="3">5000㎡以上</el-radio>
                            <el-radio label="4">100㎡以下</el-radio>
                        </el-radio-group>
                </div>
                <div class="btn_txt">
                    <span>内容说明:</span>
                    <textarea class="content" v-model="input" name="content" maxlength="800"></textarea>
                </div>
                <div class="btn" @click="goplay">
                    提交留言
                </div>
                <!-- <el-button :plain="true" @click="open3"></el-button> -->
                <!-- <el-button :plain="true" @click="open2"></el-button> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"ParticipationForm",
    data(){
        return {
             radio: "0",
             radio1: "0",
             input: '',
             hall_type:null,
             area_type:null,
             datali:['','','','',],
             tisp:"",
             success:"表单提交完成,我们尽快与您联系"
        }
    },
    methods:{
        pop1(e){
            this.hall_type = e;
        },
        pop2(e){
            this.area_type = e;
        },
        goplay(){
            if(this.hall_type == null){
                this.hall_type = this.radio
            }
            if(this.area_type == null){
                this.area_type = this.radio1
            }
            if(this.datali[0] == ''){
                this.tisp = '请输入您的称呼'
                this.open3()
            }else if(this.datali[1] == ''){
                this.tisp = '请输入您的手机号码'
                this.open3()
            }else if(this.datali[3] == ''){
                this.tisp = '请输入区域地址'
                this.open3()
            }else{
                var mobile_mode=/^1[34578]\d{9}$/;
                if (!mobile_mode.test(this.datali[1])) {
                    this.tisp = '请输入正确的手机号码'
                    this.open3()
                } else {
                    // console.log(this.hall_type)
                    // console.log(this.area_type)
                       this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/getmsg",
                        this.$qs.stringify({
                                datali:this.datali,
                                area_type:this.area_type,
                                hall_type:this.hall_type,
                                input:this.input
                        }),
                        )
                        .then(response => {            
                                // if(response.data == "邮件发送成功"){
                                            this.open2()
                                            this.datali[0] = ''
                                            this.datali[1] = ''
                                            this.datali[2] = ''
                                            this.datali[3] = ''
                                            this.input = ''
                                // }
                        })
                        .catch(error => {
                            alert("提交失败，请重试")
                        });
                }
            }
        },
        open3() {
            this.$message({
                message: this.tisp,
                type: 'warning'
            });
        },
        open2() {
            this.$message({
            message: this.success,
            type: 'success'
            });
        },
    }
}
</script>
<style scoped>
.ParticipationForm{
    height: 1180px;
    width: 100%;
}
.ParticipationForm_cennert{
    width: 1202px;
    height: 100%;
    margin: 0 auto;
}
.ParticipationForm_cennert h2{
    padding-top: 63px;
    text-align: center;
    color: #222;
    font-weight: 400;
    font-size: 34px;
    font-weight: bold;
}
.desc{
    padding-top: 12px;
    padding-bottom: 45px;
    font-size: 18px;
    color: #666666;
    text-align: center
}
.information{
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
    height: 160px;
}
.information li{
    width: 328px;
    height: 160px;
    float: left;
    margin-right: 80px;
}
.information li:nth-child(1){
    margin-left: 58px;
}

.information li:nth-child(3){
    margin-right: 0;
}
.information_top{
    width: 66px;
    height: 100%;
    float: left;
}
.information_top img{
    width: 49px;
    height: 49px;
}
.information_right{
    width: 262px;
    height: 100%;
    float: right;
}
.information_right span{
    
}
.information_right h3{
    font-size: 17px;
    color: #000000;
    margin-top: 5px;
    margin-bottom: 20px;
   

}
.information_right h5{
    font-size: 14px;
    color: #969696;
    margin-bottom: 10px;
    font-weight: normal;
    word-break: keep-all;word-wrap: break-word;
}
.information_right p{
    font-size: 12px;
    color: #aeaeae;
}
.information_right span{
    font-weight: bold;
    color: #111111;
    font-weight: bold;
}
.OnlineMessage{
    width: 1185px;
    height: 530px;
    margin:  30px auto;
}
.OnlineMessage_ptop{
    margin-left: 60px;
}
.OnlineMessage .OnlineMessage_ptop li{
    width: 540px;
    height: 40px;
    float: left;
      margin-bottom: 38px;
}
.OnlineMessage .OnlineMessage_ptop li:nth-child(2){
    margin-left: 42px;
  
}
.OnlineMessage .OnlineMessage_ptop li:nth-child(4){
     margin-left: 42px;
}
.ip{
    border-radius: 10px;
    width: 430px;
    height: 100%;
    outline: none;
    border: 1px solid #f5f3f3;
    padding-left: 10px;
    margin-left: 15px;
}
.hallType{
    margin-left: 60px;
    margin-bottom: 35px;
}
.hallType span{
    margin-right: 30px;
}
.hallType .el-radio{
    margin-right: 82px;
    font-size: 15px!important;
    font-weight: 800;
}
.area{
    margin-left: 60px;
}
.area span{
    margin-right: 30px;
}
.area .el-radio{
    margin-left: 0;
    margin-right: 0;
    /* background: red; */
    width: 149px;
    font-size: 15px!important;
    font-weight: 800;
}
.area .el-radio:nth-child(2){
    margin-right: 12px;
}
.area .el-radio:nth-child(3){
    margin-right: 28px;
}
.area .el-radio:nth-child(4){
    margin-right: 15px;
}
.btn_txt{
    margin: 43px 0px 0px 60px;
}
.btn_txt .content{
    width: 900px;
    height: 132px;
        outline: none;
    margin-left: 18px;
    border: 1px solid #f5f3f3;
    border-radius: 5px;
    padding: 5px 5px 5px 5px;
}
.btn_txt span{
    float: left;
    line-height: 132px!important;

}
.btn{
    width: 163px;
    height: 56px;
    background: #357eff;
    color: #fff;
    text-align: center;
    line-height: 56px;
    border-radius: 10px;
    margin: 54px auto;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/common/Participation/Participation-form.vue